module.exports = __webpack_public_path__ + "static/media/03.c93ab20a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentare/03.jpg
// module id = 582
// module chunks = 0